exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vue-stars label[data-v-0f0cdf40]{font-size:25px}.other-action[data-v-0f0cdf40]:hover,.payment-method[data-v-0f0cdf40]:hover{cursor:pointer}", "", {"version":3,"sources":["/app/src/components/reservation/instant/ReservationSummary.vue"],"names":[],"mappings":"AACA,kCACE,cAAgB,CACjB,AACD,4EAEE,cAAgB,CACjB","file":"ReservationSummary.vue","sourcesContent":["\n.vue-stars label[data-v-0f0cdf40] {\n  font-size: 25px;\n}\n.payment-method[data-v-0f0cdf40]:hover,\n.other-action[data-v-0f0cdf40]:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f0cdf40","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservation/instant/ReservationSummary.vue
// module id = 841
// module chunks = 52